import React from 'react'

export const ReviewChangesMessage: React.FC<{ includeCancellationWarning: boolean }> = ({
  includeCancellationWarning,
}) => {
  const subtitle = includeCancellationWarning ? 'Bets cannot be cancelled once confirmed.' : ''
  return <div>Warning: Please review changes in your betslip. {subtitle}</div>
}
